export default __webpack_public_path__ + "static/media/walk.1f17576e.svg";